// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { AuthorListView, ContentMetadataCommon, ContentId_SUMMARY, ContentItemType, Country, SummaryDocumentType, Language, KeyQuality, SummarySourceType, ContentMetadata_SUMMARY } from "../schema";
import { serialize_AuthorListView_internal, deserialize_AuthorListView_internal } from "./AuthorListView";
import { serialize_ContentMetadataCommon_internal, deserialize_ContentMetadataCommon_internal } from "./ContentMetadataCommon";
import { serialize_ContentId_SUMMARY_internal, deserialize_ContentId_SUMMARY_internal } from "./ContentId_SUMMARY";
import { serialize_ContentItemType_internal, deserialize_ContentItemType_internal } from "./ContentItemType";
import { serialize_Country_internal, deserialize_Country_internal } from "./Country";
import { serialize_SummaryDocumentType_internal, deserialize_SummaryDocumentType_internal } from "./SummaryDocumentType";
import { serialize_Language_internal, deserialize_Language_internal } from "./Language";
import { serialize_KeyQuality_internal, deserialize_KeyQuality_internal } from "./KeyQuality";
import { serialize_SummarySourceType_internal, deserialize_SummarySourceType_internal } from "./SummarySourceType";

export function serialize_ContentMetadata_SUMMARY_internal(value: ContentMetadata_SUMMARY): unknown {
  return ((value: {
    activatedAt: DateTime<true> | null;
    activationTime: DateTime<true> | null;
    active: boolean;
    audioActivatedAt: DateTime<true> | null;
    audioActive: boolean;
    audioDuration: number;
    authorInfo: string | null;
    authors: AuthorListView[];
    backgroundColor: string | null;
    bestseller: boolean;
    businessClassic: boolean;
    canonicalName: string;
    common: ContentMetadataCommon;
    contentId: ContentId_SUMMARY;
    contentItemId: bigint;
    contentItemType: ContentItemType;
    contentType: "SUMMARY";
    countriesExcluded: Country[];
    countriesIncluded: Country[];
    coverModifiedAt: DateTime<true> | null;
    coverUri: string;
    dataId: number;
    descriptionHtml: string | null;
    documentType: SummaryDocumentType;
    duration: number;
    imageBorder: boolean;
    language: Language;
    miabId: bigint | null;
    modifiedAt: DateTime<true> | null;
    originalTitle: string | null;
    previewAvailable: boolean;
    publicationDate: string | null;
    publisherInfo: string | null;
    publisherName: string | null;
    qualities: KeyQuality[];
    rating: number | null;
    sourceType: SummarySourceType;
    subtitle: string | null;
    summaryPages: number;
    summaryWords: number;
    teaser: string | null;
    title: string | null;
  }): unknown => {
    return {
      activatedAt: ((value: DateTime<true> | null): unknown => {
        if (value === null) {
          return null;
        }
        return value.toMillis();
      })(value["activatedAt"]),
      activationTime: ((value: DateTime<true> | null): unknown => {
        if (value === null) {
          return null;
        }
        return value.toMillis();
      })(value["activationTime"]),
      active: ((value: boolean): unknown => {
        return value;
      })(value["active"]),
      audioActivatedAt: ((value: DateTime<true> | null): unknown => {
        if (value === null) {
          return null;
        }
        return value.toMillis();
      })(value["audioActivatedAt"]),
      audioActive: ((value: boolean): unknown => {
        return value;
      })(value["audioActive"]),
      audioDuration: ((value: number): unknown => {
        return value;
      })(value["audioDuration"]),
      authorInfo: ((value: string | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["authorInfo"]),
      authors: ((value: AuthorListView[]): unknown => {
        return value.map((value: AuthorListView): unknown => {
          return serialize_AuthorListView_internal(value);
        });
      })(value["authors"]),
      backgroundColor: ((value: string | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["backgroundColor"]),
      bestseller: ((value: boolean): unknown => {
        return value;
      })(value["bestseller"]),
      businessClassic: ((value: boolean): unknown => {
        return value;
      })(value["businessClassic"]),
      canonicalName: ((value: string): unknown => {
        return value;
      })(value["canonicalName"]),
      common: ((value: ContentMetadataCommon): unknown => {
        return serialize_ContentMetadataCommon_internal(value);
      })(value["common"]),
      contentId: ((value: ContentId_SUMMARY): unknown => {
        return serialize_ContentId_SUMMARY_internal(value);
      })(value["contentId"]),
      contentItemId: ((value: bigint): unknown => {
        return value;
      })(value["contentItemId"]),
      contentItemType: ((value: ContentItemType): unknown => {
        return serialize_ContentItemType_internal(value);
      })(value["contentItemType"]),
      contentType: ((value: "SUMMARY"): unknown => {
        return value;
      })(value["contentType"]),
      countriesExcluded: ((value: Country[]): unknown => {
        return value.map((value: Country): unknown => {
          return serialize_Country_internal(value);
        });
      })(value["countriesExcluded"]),
      countriesIncluded: ((value: Country[]): unknown => {
        return value.map((value: Country): unknown => {
          return serialize_Country_internal(value);
        });
      })(value["countriesIncluded"]),
      coverModifiedAt: ((value: DateTime<true> | null): unknown => {
        if (value === null) {
          return null;
        }
        return value.toMillis();
      })(value["coverModifiedAt"]),
      coverUri: ((value: string): unknown => {
        return value;
      })(value["coverUri"]),
      dataId: ((value: number): unknown => {
        return value;
      })(value["dataId"]),
      descriptionHtml: ((value: string | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["descriptionHtml"]),
      documentType: ((value: SummaryDocumentType): unknown => {
        return serialize_SummaryDocumentType_internal(value);
      })(value["documentType"]),
      duration: ((value: number): unknown => {
        return value;
      })(value["duration"]),
      imageBorder: ((value: boolean): unknown => {
        return value;
      })(value["imageBorder"]),
      language: ((value: Language): unknown => {
        return serialize_Language_internal(value);
      })(value["language"]),
      miabId: ((value: bigint | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["miabId"]),
      modifiedAt: ((value: DateTime<true> | null): unknown => {
        if (value === null) {
          return null;
        }
        return value.toMillis();
      })(value["modifiedAt"]),
      originalTitle: ((value: string | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["originalTitle"]),
      previewAvailable: ((value: boolean): unknown => {
        return value;
      })(value["previewAvailable"]),
      publicationDate: ((value: string | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["publicationDate"]),
      publisherInfo: ((value: string | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["publisherInfo"]),
      publisherName: ((value: string | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["publisherName"]),
      qualities: ((value: KeyQuality[]): unknown => {
        return value.map((value: KeyQuality): unknown => {
          return serialize_KeyQuality_internal(value);
        });
      })(value["qualities"]),
      rating: ((value: number | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["rating"]),
      sourceType: ((value: SummarySourceType): unknown => {
        return serialize_SummarySourceType_internal(value);
      })(value["sourceType"]),
      subtitle: ((value: string | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["subtitle"]),
      summaryPages: ((value: number): unknown => {
        return value;
      })(value["summaryPages"]),
      summaryWords: ((value: number): unknown => {
        return value;
      })(value["summaryWords"]),
      teaser: ((value: string | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["teaser"]),
      title: ((value: string | null): unknown => {
        if (value === null) {
          return null;
        }
        return value;
      })(value["title"]),
    };
  })(value);
}
export function serialize_ContentMetadata_SUMMARY(obj: ContentMetadata_SUMMARY): string {
  return renderJsonWithNumbersAsBigint(serialize_ContentMetadata_SUMMARY_internal(obj));
}
export function deserialize_ContentMetadata_SUMMARY_internal(value: unknown): ParserResult<ContentMetadata_SUMMARY> {
  return ((
    value: unknown,
  ): ParserResult<{
    activatedAt: DateTime<true> | null;
    activationTime: DateTime<true> | null;
    active: boolean;
    audioActivatedAt: DateTime<true> | null;
    audioActive: boolean;
    audioDuration: number;
    authorInfo: string | null;
    authors: AuthorListView[];
    backgroundColor: string | null;
    bestseller: boolean;
    businessClassic: boolean;
    canonicalName: string;
    common: ContentMetadataCommon;
    contentId: ContentId_SUMMARY;
    contentItemId: bigint;
    contentItemType: ContentItemType;
    contentType: "SUMMARY";
    countriesExcluded: Country[];
    countriesIncluded: Country[];
    coverModifiedAt: DateTime<true> | null;
    coverUri: string;
    dataId: number;
    descriptionHtml: string | null;
    documentType: SummaryDocumentType;
    duration: number;
    imageBorder: boolean;
    language: Language;
    miabId: bigint | null;
    modifiedAt: DateTime<true> | null;
    originalTitle: string | null;
    previewAvailable: boolean;
    publicationDate: string | null;
    publisherInfo: string | null;
    publisherName: string | null;
    qualities: KeyQuality[];
    rating: number | null;
    sourceType: SummarySourceType;
    subtitle: string | null;
    summaryPages: number;
    summaryWords: number;
    teaser: string | null;
    title: string | null;
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "activatedAt")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/activatedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'activatedAt'.` };
    }
    const parsed_activatedAt = ((): ParserResult<DateTime<true> | null> => {
      return ((value: unknown): ParserResult<DateTime<true> | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "number") {
          return { success: false, reason: `[#/components/schemas/SummaryMetadata/activatedAt]: '${value}' expected to be of type number.` };
        }
        const parsed = DateTime.fromMillis(value);
        if (!parsed.isValid) {
          return { success: false, reason: `[#/components/schemas/SummaryMetadata/activatedAt]: '${value}' expected to be valid DateTime.` };
        }
        return { success: true, value: parsed };
      })(value["activatedAt"]);
    })();
    if (!parsed_activatedAt.success) {
      return { success: false, reason: parsed_activatedAt.reason };
    }
    if (!hasProp(value, "activationTime")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/activationTime]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'activationTime'.` };
    }
    const parsed_activationTime = ((): ParserResult<DateTime<true> | null> => {
      return ((value: unknown): ParserResult<DateTime<true> | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "number") {
          return { success: false, reason: `[#/components/schemas/SummaryMetadata/activationTime]: '${value}' expected to be of type number.` };
        }
        const parsed = DateTime.fromMillis(value);
        if (!parsed.isValid) {
          return { success: false, reason: `[#/components/schemas/SummaryMetadata/activationTime]: '${value}' expected to be valid DateTime.` };
        }
        return { success: true, value: parsed };
      })(value["activationTime"]);
    })();
    if (!parsed_activationTime.success) {
      return { success: false, reason: parsed_activationTime.reason };
    }
    if (!hasProp(value, "active")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/active]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'active'.` };
    }
    const parsed_active = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/SummaryMetadata/active]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["active"]);
    })();
    if (!parsed_active.success) {
      return { success: false, reason: parsed_active.reason };
    }
    if (!hasProp(value, "audioActivatedAt")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/audioActivatedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'audioActivatedAt'.` };
    }
    const parsed_audioActivatedAt = ((): ParserResult<DateTime<true> | null> => {
      return ((value: unknown): ParserResult<DateTime<true> | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "number") {
          return { success: false, reason: `[#/components/schemas/SummaryMetadata/audioActivatedAt]: '${value}' expected to be of type number.` };
        }
        const parsed = DateTime.fromMillis(value);
        if (!parsed.isValid) {
          return { success: false, reason: `[#/components/schemas/SummaryMetadata/audioActivatedAt]: '${value}' expected to be valid DateTime.` };
        }
        return { success: true, value: parsed };
      })(value["audioActivatedAt"]);
    })();
    if (!parsed_audioActivatedAt.success) {
      return { success: false, reason: parsed_audioActivatedAt.reason };
    }
    if (!hasProp(value, "audioActive")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/audioActive]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'audioActive'.` };
    }
    const parsed_audioActive = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/SummaryMetadata/audioActive]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["audioActive"]);
    })();
    if (!parsed_audioActive.success) {
      return { success: false, reason: parsed_audioActive.reason };
    }
    if (!hasProp(value, "audioDuration")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/audioDuration]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'audioDuration'.` };
    }
    const parsed_audioDuration = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/SummaryMetadata/audioDuration]: '${value}' expected to be of type number.` };
      })(value["audioDuration"]);
    })();
    if (!parsed_audioDuration.success) {
      return { success: false, reason: parsed_audioDuration.reason };
    }
    if (!hasProp(value, "authorInfo")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/authorInfo]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'authorInfo'.` };
    }
    const parsed_authorInfo = ((): ParserResult<string | null> => {
      return ((value: unknown): ParserResult<string | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/SummaryMetadata/authorInfo]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["authorInfo"]);
    })();
    if (!parsed_authorInfo.success) {
      return { success: false, reason: parsed_authorInfo.reason };
    }
    if (!hasProp(value, "authors")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/authors]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'authors'.` };
    }
    const parsed_authors = ((): ParserResult<AuthorListView[]> => {
      return ((value: unknown): ParserResult<AuthorListView[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/SummaryMetadata/authors]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<AuthorListView> => {
          return deserialize_AuthorListView_internal(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/SummaryMetadata/authors]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["authors"]);
    })();
    if (!parsed_authors.success) {
      return { success: false, reason: parsed_authors.reason };
    }
    if (!hasProp(value, "backgroundColor")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/backgroundColor]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'backgroundColor'.` };
    }
    const parsed_backgroundColor = ((): ParserResult<string | null> => {
      return ((value: unknown): ParserResult<string | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/SummaryMetadata/backgroundColor]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["backgroundColor"]);
    })();
    if (!parsed_backgroundColor.success) {
      return { success: false, reason: parsed_backgroundColor.reason };
    }
    if (!hasProp(value, "bestseller")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/bestseller]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'bestseller'.` };
    }
    const parsed_bestseller = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/SummaryMetadata/bestseller]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["bestseller"]);
    })();
    if (!parsed_bestseller.success) {
      return { success: false, reason: parsed_bestseller.reason };
    }
    if (!hasProp(value, "businessClassic")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/businessClassic]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'businessClassic'.` };
    }
    const parsed_businessClassic = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/SummaryMetadata/businessClassic]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["businessClassic"]);
    })();
    if (!parsed_businessClassic.success) {
      return { success: false, reason: parsed_businessClassic.reason };
    }
    if (!hasProp(value, "canonicalName")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/canonicalName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'canonicalName'.` };
    }
    const parsed_canonicalName = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/SummaryMetadata/canonicalName]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["canonicalName"]);
    })();
    if (!parsed_canonicalName.success) {
      return { success: false, reason: parsed_canonicalName.reason };
    }
    if (!hasProp(value, "common")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/common]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'common'.` };
    }
    const parsed_common = ((): ParserResult<ContentMetadataCommon> => {
      return ((value: unknown): ParserResult<ContentMetadataCommon> => {
        return deserialize_ContentMetadataCommon_internal(value);
      })(value["common"]);
    })();
    if (!parsed_common.success) {
      return { success: false, reason: parsed_common.reason };
    }
    if (!hasProp(value, "contentId")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/contentId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contentId'.` };
    }
    const parsed_contentId = ((): ParserResult<ContentId_SUMMARY> => {
      return ((value: unknown): ParserResult<ContentId_SUMMARY> => {
        return deserialize_ContentId_SUMMARY_internal(value);
      })(value["contentId"]);
    })();
    if (!parsed_contentId.success) {
      return { success: false, reason: parsed_contentId.reason };
    }
    if (!hasProp(value, "contentItemId")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/contentItemId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contentItemId'.` };
    }
    const parsed_contentItemId = ((): ParserResult<bigint> => {
      return ((value: unknown): ParserResult<bigint> => {
        if (typeof value === "number") {
          return { success: true, value: BigInt(value) };
        }
        if (typeof value === "bigint") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/SummaryMetadata/contentItemId]: '${value}' expected to be of type bigint or number.` };
      })(value["contentItemId"]);
    })();
    if (!parsed_contentItemId.success) {
      return { success: false, reason: parsed_contentItemId.reason };
    }
    if (!hasProp(value, "contentItemType")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/contentItemType]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contentItemType'.` };
    }
    const parsed_contentItemType = ((): ParserResult<ContentItemType> => {
      return ((value: unknown): ParserResult<ContentItemType> => {
        return deserialize_ContentItemType_internal(value);
      })(value["contentItemType"]);
    })();
    if (!parsed_contentItemType.success) {
      return { success: false, reason: parsed_contentItemType.reason };
    }
    if (!hasProp(value, "contentType")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/contentType]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'contentType'.` };
    }
    const parsed_contentType = ((): ParserResult<"SUMMARY"> => {
      return ((value: unknown): ParserResult<"SUMMARY"> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/SummaryMetadata/contentType]: '${value}' expected to be of type string.` };
        }
        switch (value) {
          case "SUMMARY":
            return { success: true, value: "SUMMARY" };
          default:
            return { success: false, reason: `[#/components/schemas/SummaryMetadata/contentType]: '${value}' expected to be enum, one of 'SUMMARY'.` };
        }
      })(value["contentType"]);
    })();
    if (!parsed_contentType.success) {
      return { success: false, reason: parsed_contentType.reason };
    }
    if (!hasProp(value, "countriesExcluded")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/countriesExcluded]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'countriesExcluded'.` };
    }
    const parsed_countriesExcluded = ((): ParserResult<Country[]> => {
      return ((value: unknown): ParserResult<Country[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/SummaryMetadata/countriesExcluded]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<Country> => {
          return deserialize_Country_internal(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/SummaryMetadata/countriesExcluded]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["countriesExcluded"]);
    })();
    if (!parsed_countriesExcluded.success) {
      return { success: false, reason: parsed_countriesExcluded.reason };
    }
    if (!hasProp(value, "countriesIncluded")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/countriesIncluded]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'countriesIncluded'.` };
    }
    const parsed_countriesIncluded = ((): ParserResult<Country[]> => {
      return ((value: unknown): ParserResult<Country[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/SummaryMetadata/countriesIncluded]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<Country> => {
          return deserialize_Country_internal(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/SummaryMetadata/countriesIncluded]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["countriesIncluded"]);
    })();
    if (!parsed_countriesIncluded.success) {
      return { success: false, reason: parsed_countriesIncluded.reason };
    }
    if (!hasProp(value, "coverModifiedAt")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/coverModifiedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'coverModifiedAt'.` };
    }
    const parsed_coverModifiedAt = ((): ParserResult<DateTime<true> | null> => {
      return ((value: unknown): ParserResult<DateTime<true> | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "number") {
          return { success: false, reason: `[#/components/schemas/SummaryMetadata/coverModifiedAt]: '${value}' expected to be of type number.` };
        }
        const parsed = DateTime.fromMillis(value);
        if (!parsed.isValid) {
          return { success: false, reason: `[#/components/schemas/SummaryMetadata/coverModifiedAt]: '${value}' expected to be valid DateTime.` };
        }
        return { success: true, value: parsed };
      })(value["coverModifiedAt"]);
    })();
    if (!parsed_coverModifiedAt.success) {
      return { success: false, reason: parsed_coverModifiedAt.reason };
    }
    if (!hasProp(value, "coverUri")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/coverUri]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'coverUri'.` };
    }
    const parsed_coverUri = ((): ParserResult<string> => {
      return ((value: unknown): ParserResult<string> => {
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/SummaryMetadata/coverUri]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["coverUri"]);
    })();
    if (!parsed_coverUri.success) {
      return { success: false, reason: parsed_coverUri.reason };
    }
    if (!hasProp(value, "dataId")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/dataId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'dataId'.` };
    }
    const parsed_dataId = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/SummaryMetadata/dataId]: '${value}' expected to be of type number.` };
      })(value["dataId"]);
    })();
    if (!parsed_dataId.success) {
      return { success: false, reason: parsed_dataId.reason };
    }
    if (!hasProp(value, "descriptionHtml")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/descriptionHtml]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'descriptionHtml'.` };
    }
    const parsed_descriptionHtml = ((): ParserResult<string | null> => {
      return ((value: unknown): ParserResult<string | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/SummaryMetadata/descriptionHtml]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["descriptionHtml"]);
    })();
    if (!parsed_descriptionHtml.success) {
      return { success: false, reason: parsed_descriptionHtml.reason };
    }
    if (!hasProp(value, "documentType")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/documentType]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'documentType'.` };
    }
    const parsed_documentType = ((): ParserResult<SummaryDocumentType> => {
      return ((value: unknown): ParserResult<SummaryDocumentType> => {
        return deserialize_SummaryDocumentType_internal(value);
      })(value["documentType"]);
    })();
    if (!parsed_documentType.success) {
      return { success: false, reason: parsed_documentType.reason };
    }
    if (!hasProp(value, "duration")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/duration]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'duration'.` };
    }
    const parsed_duration = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/SummaryMetadata/duration]: '${value}' expected to be of type number.` };
      })(value["duration"]);
    })();
    if (!parsed_duration.success) {
      return { success: false, reason: parsed_duration.reason };
    }
    if (!hasProp(value, "imageBorder")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/imageBorder]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'imageBorder'.` };
    }
    const parsed_imageBorder = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/SummaryMetadata/imageBorder]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["imageBorder"]);
    })();
    if (!parsed_imageBorder.success) {
      return { success: false, reason: parsed_imageBorder.reason };
    }
    if (!hasProp(value, "language")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/language]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'language'.` };
    }
    const parsed_language = ((): ParserResult<Language> => {
      return ((value: unknown): ParserResult<Language> => {
        return deserialize_Language_internal(value);
      })(value["language"]);
    })();
    if (!parsed_language.success) {
      return { success: false, reason: parsed_language.reason };
    }
    if (!hasProp(value, "miabId")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/miabId]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'miabId'.` };
    }
    const parsed_miabId = ((): ParserResult<bigint | null> => {
      return ((value: unknown): ParserResult<bigint | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value === "number") {
          return { success: true, value: BigInt(value) };
        }
        if (typeof value === "bigint") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/SummaryMetadata/miabId]: '${value}' expected to be of type bigint or number.` };
      })(value["miabId"]);
    })();
    if (!parsed_miabId.success) {
      return { success: false, reason: parsed_miabId.reason };
    }
    if (!hasProp(value, "modifiedAt")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/modifiedAt]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'modifiedAt'.` };
    }
    const parsed_modifiedAt = ((): ParserResult<DateTime<true> | null> => {
      return ((value: unknown): ParserResult<DateTime<true> | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "number") {
          return { success: false, reason: `[#/components/schemas/SummaryMetadata/modifiedAt]: '${value}' expected to be of type number.` };
        }
        const parsed = DateTime.fromMillis(value);
        if (!parsed.isValid) {
          return { success: false, reason: `[#/components/schemas/SummaryMetadata/modifiedAt]: '${value}' expected to be valid DateTime.` };
        }
        return { success: true, value: parsed };
      })(value["modifiedAt"]);
    })();
    if (!parsed_modifiedAt.success) {
      return { success: false, reason: parsed_modifiedAt.reason };
    }
    if (!hasProp(value, "originalTitle")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/originalTitle]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'originalTitle'.` };
    }
    const parsed_originalTitle = ((): ParserResult<string | null> => {
      return ((value: unknown): ParserResult<string | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/SummaryMetadata/originalTitle]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["originalTitle"]);
    })();
    if (!parsed_originalTitle.success) {
      return { success: false, reason: parsed_originalTitle.reason };
    }
    if (!hasProp(value, "previewAvailable")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/previewAvailable]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'previewAvailable'.` };
    }
    const parsed_previewAvailable = ((): ParserResult<boolean> => {
      return ((value: unknown): ParserResult<boolean> => {
        if (typeof value !== "boolean") {
          return { success: false, reason: `[#/components/schemas/SummaryMetadata/previewAvailable]: '${value}' expected to be of type boolean.` };
        }
        return { success: true, value: value };
      })(value["previewAvailable"]);
    })();
    if (!parsed_previewAvailable.success) {
      return { success: false, reason: parsed_previewAvailable.reason };
    }
    if (!hasProp(value, "publicationDate")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/publicationDate]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'publicationDate'.` };
    }
    const parsed_publicationDate = ((): ParserResult<string | null> => {
      return ((value: unknown): ParserResult<string | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/SummaryMetadata/publicationDate]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["publicationDate"]);
    })();
    if (!parsed_publicationDate.success) {
      return { success: false, reason: parsed_publicationDate.reason };
    }
    if (!hasProp(value, "publisherInfo")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/publisherInfo]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'publisherInfo'.` };
    }
    const parsed_publisherInfo = ((): ParserResult<string | null> => {
      return ((value: unknown): ParserResult<string | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/SummaryMetadata/publisherInfo]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["publisherInfo"]);
    })();
    if (!parsed_publisherInfo.success) {
      return { success: false, reason: parsed_publisherInfo.reason };
    }
    if (!hasProp(value, "publisherName")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/publisherName]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'publisherName'.` };
    }
    const parsed_publisherName = ((): ParserResult<string | null> => {
      return ((value: unknown): ParserResult<string | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/SummaryMetadata/publisherName]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["publisherName"]);
    })();
    if (!parsed_publisherName.success) {
      return { success: false, reason: parsed_publisherName.reason };
    }
    if (!hasProp(value, "qualities")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/qualities]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'qualities'.` };
    }
    const parsed_qualities = ((): ParserResult<KeyQuality[]> => {
      return ((value: unknown): ParserResult<KeyQuality[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/SummaryMetadata/qualities]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<KeyQuality> => {
          return deserialize_KeyQuality_internal(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/SummaryMetadata/qualities]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["qualities"]);
    })();
    if (!parsed_qualities.success) {
      return { success: false, reason: parsed_qualities.reason };
    }
    if (!hasProp(value, "rating")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/rating]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'rating'.` };
    }
    const parsed_rating = ((): ParserResult<number | null> => {
      return ((value: unknown): ParserResult<number | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/SummaryMetadata/rating]: '${value}' expected to be of type number.` };
      })(value["rating"]);
    })();
    if (!parsed_rating.success) {
      return { success: false, reason: parsed_rating.reason };
    }
    if (!hasProp(value, "sourceType")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/sourceType]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'sourceType'.` };
    }
    const parsed_sourceType = ((): ParserResult<SummarySourceType> => {
      return ((value: unknown): ParserResult<SummarySourceType> => {
        return deserialize_SummarySourceType_internal(value);
      })(value["sourceType"]);
    })();
    if (!parsed_sourceType.success) {
      return { success: false, reason: parsed_sourceType.reason };
    }
    if (!hasProp(value, "subtitle")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/subtitle]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'subtitle'.` };
    }
    const parsed_subtitle = ((): ParserResult<string | null> => {
      return ((value: unknown): ParserResult<string | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/SummaryMetadata/subtitle]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["subtitle"]);
    })();
    if (!parsed_subtitle.success) {
      return { success: false, reason: parsed_subtitle.reason };
    }
    if (!hasProp(value, "summaryPages")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/summaryPages]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'summaryPages'.` };
    }
    const parsed_summaryPages = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/SummaryMetadata/summaryPages]: '${value}' expected to be of type number.` };
      })(value["summaryPages"]);
    })();
    if (!parsed_summaryPages.success) {
      return { success: false, reason: parsed_summaryPages.reason };
    }
    if (!hasProp(value, "summaryWords")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/summaryWords]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'summaryWords'.` };
    }
    const parsed_summaryWords = ((): ParserResult<number> => {
      return ((value: unknown): ParserResult<number> => {
        if (typeof value === "number") {
          return { success: true, value: value };
        }
        return { success: false, reason: `[#/components/schemas/SummaryMetadata/summaryWords]: '${value}' expected to be of type number.` };
      })(value["summaryWords"]);
    })();
    if (!parsed_summaryWords.success) {
      return { success: false, reason: parsed_summaryWords.reason };
    }
    if (!hasProp(value, "teaser")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/teaser]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'teaser'.` };
    }
    const parsed_teaser = ((): ParserResult<string | null> => {
      return ((value: unknown): ParserResult<string | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/SummaryMetadata/teaser]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["teaser"]);
    })();
    if (!parsed_teaser.success) {
      return { success: false, reason: parsed_teaser.reason };
    }
    if (!hasProp(value, "title")) {
      return { success: false, reason: `[#/components/schemas/SummaryMetadata/title]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'title'.` };
    }
    const parsed_title = ((): ParserResult<string | null> => {
      return ((value: unknown): ParserResult<string | null> => {
        if (value === null) {
          return { success: true, value: null };
        }
        if (typeof value !== "string") {
          return { success: false, reason: `[#/components/schemas/SummaryMetadata/title]: '${value}' expected to be of type string.` };
        }
        return { success: true, value: value };
      })(value["title"]);
    })();
    if (!parsed_title.success) {
      return { success: false, reason: parsed_title.reason };
    }
    return {
      success: true,
      value: {
        activatedAt: parsed_activatedAt.value,
        activationTime: parsed_activationTime.value,
        active: parsed_active.value,
        audioActivatedAt: parsed_audioActivatedAt.value,
        audioActive: parsed_audioActive.value,
        audioDuration: parsed_audioDuration.value,
        authorInfo: parsed_authorInfo.value,
        authors: parsed_authors.value,
        backgroundColor: parsed_backgroundColor.value,
        bestseller: parsed_bestseller.value,
        businessClassic: parsed_businessClassic.value,
        canonicalName: parsed_canonicalName.value,
        common: parsed_common.value,
        contentId: parsed_contentId.value,
        contentItemId: parsed_contentItemId.value,
        contentItemType: parsed_contentItemType.value,
        contentType: parsed_contentType.value,
        countriesExcluded: parsed_countriesExcluded.value,
        countriesIncluded: parsed_countriesIncluded.value,
        coverModifiedAt: parsed_coverModifiedAt.value,
        coverUri: parsed_coverUri.value,
        dataId: parsed_dataId.value,
        descriptionHtml: parsed_descriptionHtml.value,
        documentType: parsed_documentType.value,
        duration: parsed_duration.value,
        imageBorder: parsed_imageBorder.value,
        language: parsed_language.value,
        miabId: parsed_miabId.value,
        modifiedAt: parsed_modifiedAt.value,
        originalTitle: parsed_originalTitle.value,
        previewAvailable: parsed_previewAvailable.value,
        publicationDate: parsed_publicationDate.value,
        publisherInfo: parsed_publisherInfo.value,
        publisherName: parsed_publisherName.value,
        qualities: parsed_qualities.value,
        rating: parsed_rating.value,
        sourceType: parsed_sourceType.value,
        subtitle: parsed_subtitle.value,
        summaryPages: parsed_summaryPages.value,
        summaryWords: parsed_summaryWords.value,
        teaser: parsed_teaser.value,
        title: parsed_title.value,
      },
    };
  })(value);
}
export function deserialize_ContentMetadata_SUMMARY(str: string): ParserResult<ContentMetadata_SUMMARY> {
  return deserialize_ContentMetadata_SUMMARY_internal(parseJsonWithNumbersAsBigint(str));
}
